export const TABLE_SIZE = "small";
export const QUERY_FORM_SIZE = "small";
